import { EsignLibModule } from '@ag/sd.esign-visual-library';
import { AgUiModule } from '@ag/vc.ag-ui';
import { AgLoadingModule } from '@ag/vc.ag-ui/loading';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID, ErrorHandler } from '@angular/core';
import { AppRoutingModule } from './shared/routing/app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { CoreModule } from './core/core.module';
import { FormsModule } from '@angular/forms';
import localeNlBe from '@angular/common/locales/nl-BE';
import { registerLocaleData } from '@angular/common';
import { ContextModule } from './modules/context/context.module';
import { HttpInterceptorsService } from './shared/services/http-interceptors.service';
// import { NgxLoadingSpinnerModule } from '@k-adam/ngx-loading-spinner';
import { GlobalErrorHandlerService } from './shared/services/global-error-handler.service';
import { ApplicationInsightsService } from './shared/services/application-insights.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AgTokenInterceptor } from '@ag/vc.ag-core/authentication';

registerLocaleData(localeNlBe);

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent
  ],
  imports: [
    BrowserModule,
    // NgxLoadingSpinnerModule.forRoot(),
    EsignLibModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AgUiModule.forRoot({
      allowedLanguages: ['nl', 'fr'],
      defaultLanguage: 'fr'
    }),
    AgLoadingModule,
    HttpClientModule,
    SharedModule.forRoot(),
    ModalModule.forRoot(),
    CoreModule,
    FormsModule,
    ContextModule
  ],
  providers: [
    {
      provide: LOCALE_ID, useValue: 'nl-BE'
    },
    { provide: HTTP_INTERCEPTORS, useClass: AgTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorsService, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: ApplicationInsightsService }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
